import React from 'react'
import { tagColor } from './tagColor'

export const Tag = ({
  text,
  className,
}: {
  text: string
  className: string
}) => (
  <div className='flex justify-center items-center min-h-6'>
    <span
      className={`${
        tagColor[text] ?? 'bg-gray-300'
      } ${className} rounded-xl tracking-wide`}
    >
      {text}
    </span>
  </div>
)
